<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block" v-loading="Loading">
      <h3>{{dataInfo.title}}</h3>
      <div class="titleF">
        发布时间：<span> {{dataInfo.publicTime}}</span>
        <div v-if="dataInfo.origin" style="display: inline-block;">来源：<span>{{dataInfo.origin}}</span></div>
        浏览量：<span>{{dataInfo.pv}}</span>
      </div>
      <div class="container">
        <img class="cover" v-if="dataInfo.imgUrl" :src="dataInfo.imgUrl" />
        <div class="contentsss" v-html="dataInfo.content"></div>
        <ul v-if="dataInfo.projectFiles.length > 0 " class="ul_wrap">
          <div>附件：</div>
          <li v-for="item in dataInfo.projectFiles" :key="item.id">
            <el-link style="color: rgb(4, 126, 255)" :underline="false" :href="item.fileAddr" target="_blank">{{item.fileName}}</el-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderImg from '@/components/HeaderImg';
export default {
  components: {
    HeaderImg
  },
  data() {
    return {
      headerList: [
        { name: '首页', path: '/Home' },
        { name: '新闻公告', path: '/NewsList' },
        { name: '新闻公告详情', path: '' }
      ],
      Loading: false,
      dataInfo: {
        aeraConfigId: '',
        aeraConfigName: '',
        configType: '',
        content: '',
        createdTime: '',
        description: '',
        id: '',
        imgUrl: '',
        modifyTime: '',
        origin: '',
        publicTime: '',
        pv: '',
        systemConfigId: '',
        systemConfigName: '',
        title: '',
        topState: '',
        projectFiles: []
      }
    };
  },
  methods: {
    getDataList() {
      this.Loading = true;
      this.$api.user
        .queryProjectNoticeDetail({ id: this.$route.query.id })
        .then(res => {
          if (res.code == 1000) {
            this.dataInfo = res.data;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(error => {})
        .finally(() => {
          this.Loading = false;
        });
    }
  },
  mounted() {
    this.getDataList();
  }
};
</script>
<style lang="scss" >
.contentsss {
  text-indent: 2em;
  overflow: hidden;
  img {
    display: block;
    margin: 10px auto;
    max-width: 100%;
  }
}
</style>
<style lang="scss" scoped>
h3 {
  text-align: center;
  font-size: 30px;
  color: #1d1d1f;
  letter-spacing: 0;
}
.titleF {
  text-align: center;
  color: #a5a5a5;
  padding: 0 45px 14px;
  border-bottom: 1px solid #ebecef;
  span {
    padding-right: 30px;
  }
}
.container {
  margin: 30px auto;
  font-size: 16px;
  .cover {
    max-width: 100%;
    overflow: hidden;
    display: block;
    margin: auto;
  }
  .ul_wrap {
    list-style: none;
  }
}
</style>